import { type RequirementIdentifier } from '@capsicum/common';
import { usePauseCredentialsWebSocketsListener } from '@capsicum/features/regulations/shared';

import { useForcedRequirementsDismiss } from '../../hooks/useForcedRequirementsDismiss';

import { Requirement } from './Requirement';

type ForcedRequirementsHandlerProps = {
	requirementIdentifier: RequirementIdentifier;
};

export const ForcedRequirementsHandler = ({ requirementIdentifier }: ForcedRequirementsHandlerProps) => {
	const { onDismiss } = useForcedRequirementsDismiss();

	usePauseCredentialsWebSocketsListener();

	return <Requirement isForcedRequirement requirementIdentifier={requirementIdentifier} onDismiss={onDismiss} />;
};
